// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g65JJDeQnCktlzqM28kL{height:100%;padding-right:17px}.g65JJDeQnCktlzqM28kL .YowkKtlAwskfZOqbl1j5{flex-direction:column;gap:2px;display:flex}.BZn9V84xIK0Vz5C25m8y{flex-direction:column;justify-content:center;align-items:center;gap:16px;width:100%;height:100%;display:flex}.P9Z4CJM0O9gYRAXn8m6K{align-items:center;height:32px;padding-left:12px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapList": `g65JJDeQnCktlzqM28kL`,
	"list": `YowkKtlAwskfZOqbl1j5`,
	"empty": `BZn9V84xIK0Vz5C25m8y`,
	"wrapLabel": `P9Z4CJM0O9gYRAXn8m6K`
};
export default ___CSS_LOADER_EXPORT___;
